const useScroll = () => {
  const scrollToId = (id) => {
    try {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    } catch (error) {
      console.log('useScroll error: id not yet loaded');
    }
  };

  const scrollToTop = () => {
    setTimeout(() => {
      scrollToId('header');
    }, 100);
  };

  return { scrollToId, scrollToTop };
};

export default useScroll;
